import { Button, Dialog, DialogContent, DialogTitle } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { JahrMonat } from '@/domain/controlling/entities';

export function ConfirmDialog({
  open,
  onOpenChange,
  redirectTo,
  type,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  redirectTo: JahrMonat;
  type: 'ziele' | 'planwerte';
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleDismiss() {
    navigate(
      `/controlling/umsatzplanung/${redirectTo.jahr}/${redirectTo.monat}`,
      {
        replace: true,
      },
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[444px] p-8 flex flex-col gap-6">
        <DialogTitle>
          {t('domain.controlling.umsatzplanung.alertUnsavedChanges.header')}
        </DialogTitle>
        <div className="text-sm text-neutrals-900">
          {t('domain.controlling.umsatzplanung.alertUnsavedChanges.subHeader', {
            type: type === 'ziele' ? 'Monat' : 'Tag',
          })}
        </div>
        <div className="flex items-center justify-end gap-4">
          <Button
            onClick={() => {
              onOpenChange(false);
              handleDismiss();
            }}
            variant="outline">
            {t('actions.verlassen')}
          </Button>
          <Button onClick={() => onOpenChange(false)}>
            {t('actions.weiterBearbeiten')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
